var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChampselectLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_998)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_208_998)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#81B9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2836 50.2326L42.7077 21.9844L10.2686 35.9024L18.6133 41.8587L16.9163 42.5868L56.4921 70.835L88.9313 56.917L80.5865 50.9607L82.2836 50.2326Z",
    fill: "url(#paint0_linear_208_998)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9552 14.2339C25.5988 14.2339 24.4992 15.3335 24.4992 16.69V16.9267C18.0243 18.6323 13.3856 23.2333 13.3856 28.6415C13.3856 28.7204 13.3865 28.799 13.3885 28.8775H13.2914C11.6219 28.8775 10.2686 30.2309 10.2686 31.9004V35.2067C10.2686 36.8762 11.6219 38.2296 13.2914 38.2296H15.0311C15.3332 42.8077 19.1424 46.4276 23.797 46.4276H36.3204C40.9751 46.4276 44.7842 42.8077 45.0864 38.2296H46.8267C48.4962 38.2296 49.8496 36.8762 49.8496 35.2067V31.9004C49.8496 30.2309 48.4962 28.8775 46.8267 28.8775H46.7288C46.7308 28.799 46.7318 28.7204 46.7318 28.6415C46.7318 23.2336 42.0935 18.6328 35.6191 16.9269V16.69C35.6191 15.3335 34.5195 14.2339 33.163 14.2339H26.9552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.0588,
    cy: 33.949,
    rx: 12.7908,
    ry: 7.63556,
    fill: "#E7EAED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0917 15.7114C26.5008 15.7114 26.0218 16.1905 26.0218 16.7814V18.0459C26.0218 18.6368 26.5008 19.1158 27.0917 19.1158H33.0251C33.616 19.1158 34.0951 18.6368 34.0951 18.0459V16.7814C34.0951 16.1905 33.616 15.7114 33.0251 15.7114H27.0917ZM23.5171 31.9684C23.5171 31.2553 24.0952 30.6772 24.8083 30.6772C25.5214 30.6772 26.0995 31.2553 26.0995 31.9684V36.0841C26.0995 36.7972 25.5214 37.3753 24.8083 37.3753C24.0952 37.3753 23.5171 36.7972 23.5171 36.0841V31.9684ZM35.1179 34.3358C34.5656 34.4343 34.0915 34.7914 33.848 35.0836C33.4201 35.5973 32.6568 35.6667 32.1432 35.2388C31.6295 34.8108 31.5601 34.0475 31.988 33.5339C32.5056 32.9127 33.4532 32.1736 34.6926 31.9524C36.0135 31.7167 37.4792 32.1035 38.8487 33.4435C39.3265 33.9111 39.3349 34.6775 38.8674 35.1554C38.3998 35.6332 37.6334 35.6416 37.1556 35.174C36.2844 34.3217 35.5886 34.2518 35.1179 34.3358ZM26.0218 20.4778C26.0218 20.048 26.3702 19.6996 26.7999 19.6996H33.3169C33.7467 19.6996 34.0951 20.048 34.0951 20.4778V21.0614C34.0951 21.4912 33.7467 21.8395 33.3169 21.8395H26.7999C26.3702 21.8395 26.0218 21.4912 26.0218 21.0614V20.4778ZM26.5081 22.4228C26.2395 22.4228 26.0218 22.6406 26.0218 22.9092V23.1037C26.0218 23.3723 26.2395 23.59 26.5081 23.59H33.6087C33.8773 23.59 34.0951 23.3723 34.0951 23.1037V22.9092C34.0951 22.6406 33.8773 22.4228 33.6087 22.4228H26.5081Z",
    fill: "#6DA5E6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_998",
    x1: 29.6893,
    y1: 32.7999,
    x2: 53.4311,
    y2: 49.5141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CA5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CA5E6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_208_998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.1172,
    height: 60.1172,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampselectLogo);
export default __webpack_public_path__ + "static/media/champselect-logo.e9587e6e232a658df3c39decd079beed.svg";
export { ForwardRef as ReactComponent };